import React from 'react';
import ReactDOM from 'react-dom';
import { QuoteSummaryDialog } from 'src/components/reports/transactions/transaction-summary/quote-summary';

export const QuoteSummaryDialogInitializer = ({ quoteId, onClose }, node) => {
  return {
    destroy: () => ReactDOM.unmountComponentAtNode(node),
    render: () => {
      ReactDOM.render(<QuoteSummaryDialog quoteId={quoteId} onClose={onClose} />, node);
    },
  };
};
